import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { SerieListItem, SerieRequest } from '../types/serie';
import { SerieService } from '../services/serieService';

interface SerieStore {
  series: SerieListItem[];
  loading: boolean;
  error: string | null;
  fetchSeries: () => Promise<void>;
  saveSerie: (data: SerieRequest, idTalonario?: number) => Promise<void>;
  deleteSerie: (id: number) => Promise<void>;
  clearError: () => void;
}

export const useSerieStore = create<SerieStore>()(
  devtools(
    (set, get) => ({
      series: [],
      loading: false,
      error: null,

      fetchSeries: async () => {
        set({ loading: true, error: null }, false, 'serie/fetch');
        try {
          const series = await SerieService.getAll();
          set({ series, loading: false }, false, 'serie/fetch/success');
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Error al cargar series',
            loading: false,
          }, false, 'serie/fetch/error');
        }
      },

      saveSerie: async (data: SerieRequest, idTalonario?: number) => {
        set({ loading: true, error: null }, false, 'serie/save');
        try {
          if (idTalonario) {
            await SerieService.update(idTalonario, data);
          } else {
            await SerieService.create(data);
          }
          await get().fetchSeries();
          set({ loading: false }, false, 'serie/save/success');
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Error al guardar serie',
            loading: false,
          }, false, 'serie/save/error');
          throw error;
        }
      },

      deleteSerie: async (id: number) => {
        set({ loading: true, error: null }, false, 'serie/delete');
        try {
          await SerieService.remove(id);
          await get().fetchSeries();
          set({ loading: false }, false, 'serie/delete/success');
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Error al eliminar serie',
            loading: false,
          }, false, 'serie/delete/error');
        }
      },

      clearError: () => set({ error: null }),
    }),
    { name: 'serie-store' }
  )
);
